import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/v1/kubernetes/clusters/:clusterId/actions', () => {
    return HttpResponse.json({ items: [] });
  }),
];

export default handlers;
